export default "__VITE_ASSET__Bz8fUpC4__"